import React, { Component } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Cell,
  ResponsiveContainer,
  Label
} from "recharts";

const inPersonWorkers = 990000;
const onlineWorkers = 701000;
const totalWorkers = 1609000;
const style = {
  fontFamily: "canada-type-gibson, sans-serif"
};
const blue = "#0164B3";
const magenta = "#E3007D";
const navy = "#1B3D67";

const data = [
  {
    name: "In person workers",
    "Percent of workers": (inPersonWorkers * 100) / totalWorkers
  },
  {
    name: "Online workers",
    "Percent of workers": (onlineWorkers * 100) / totalWorkers
  },
  {
    name: "Both",
    "Percent of workers":
      ((onlineWorkers + inPersonWorkers - totalWorkers) * 100) / totalWorkers
  }
];

class App extends Component {
  render() {
    return (
      <ResponsiveContainer width="80%" height={200}>
        <BarChart
          data={data}
          layout="vertical"
          margin={{ top: 20, right: 0, left: 25, bottom: 20 }}
        >
          <XAxis type="number" domain={[0, 100]} contentStyle={style}></XAxis>
          <YAxis type="category" dataKey="name" />
          <Bar dataKey="Percent of workers">
            {data.map((entry, index) => {
              var color;
              if (data[index].name === "In person workers") {
                color = blue;
              } else if (data[index].name === "Online workers") {
                color = magenta;
              } else {
                color = navy;
              }
              return <Cell fill={color} />;
            })}
          </Bar>

          <Tooltip
            formatter={value => value.toFixed(1) + "%"}
            cursor={false}
            contentStyle={style}
          />
        </BarChart>
      </ResponsiveContainer>
    );
  }
}

export default App;
